import {
    bulkActionChangeSubmit,
    getActiveModule,
    hideChangeBid,
    showChangeBid,
} from "@ts/utils";
import BulkActionsMenu from "@drop-downs/BulkActionsMenu";
import { useSelector } from "react-redux";
import $ from "jquery";
import {
    Channels,
    IChannel,
    IValueBoolean,
    ParentModule,
} from "@ts/common-types";
import { useGetBulkActionsMenuData } from "@hooks/useGetBulkActionsMenuData";
import UpdateBidOrBudgetModal from "../modals/UpdateBidOrBudgetModal";

type TCustomModalDisp = {
    customModalDisp: IValueBoolean;
};

const KeywordsBulkOperationsBtns = () => {
    const { activeModule } = getActiveModule();
    const bulkActionData = useGetBulkActionsMenuData();
    const customModalDisp = useSelector(
        (state: TCustomModalDisp) => state.customModalDisp.value
    );
    const channel = useSelector((state: IChannel) => state.channel.value);
    return customModalDisp ? (
        <>
            {activeModule === ParentModule.KEYWORD_ANALYTICS ? (
                <>
                    <div
                        className="position-relative"
                        id="keywords-bulk-operations-div"
                        style={{
                            display: "none",
                        }}
                    >
                        <div className="d-flex">
                            <div>
                                <button
                                    id="bulk-update-bid-btn"
                                    className="btn btn-sm mx-2 btn-primary"
                                    style={{ width: "100px" }}
                                    type="button"
                                    onClick={() => {
                                        $("#saveFiltersBtn").css({
                                            display: "none",
                                        });
                                        showChangeBid();
                                    }}
                                >
                                    Update Bid
                                </button>
                                <button
                                    id="bulk-pause-bid-btn"
                                    className="btn btn-sm btn-danger"
                                    style={{
                                        display:
                                            channel === Channels.AMAZON
                                                ? "unset"
                                                : "none",
                                    }}
                                    type="button"
                                    data-bs-name="Pause"
                                    onClick={(event) => {
                                        bulkActionChangeSubmit(
                                            "pause",
                                            "keywords",
                                            { isBulkAction: true, event }
                                        );
                                    }}
                                >
                                    Pause
                                </button>
                                <button
                                    id="bulk-enable-bid-btn"
                                    className="btn btn-sm mx-2 btn-success"
                                    style={{
                                        display:
                                            channel === Channels.AMAZON
                                                ? "unset"
                                                : "none",
                                    }}
                                    type="button"
                                    data-bs-name="Enable"
                                    onClick={(event) =>
                                        bulkActionChangeSubmit(
                                            "enable",
                                            "keywords",
                                            { isBulkAction: true, event }
                                        )
                                    }
                                >
                                    Enable
                                </button>
                                <button
                                    id="bulk-negative-bid-btn"
                                    className="btn btn-sm btn-secondary rounded-end"
                                    style={{
                                        display:
                                            channel === Channels.AMAZON
                                                ? "unset"
                                                : "none",
                                    }}
                                    type="button"
                                    data-bs-name="Mark as Negative"
                                    onClick={(event) =>
                                        bulkActionChangeSubmit(
                                            "markNegative",
                                            "keywords",
                                            { isBulkAction: true, event }
                                        )
                                    }
                                >
                                    Mark as Negative
                                </button>
                            </div>

                            <div
                                className="position-absolute bg-white h-100"
                                id="updateBidDiv"
                                style={{
                                    display: "none",
                                    zIndex: 999,
                                    minWidth: "350px",
                                    right: "0px",
                                }}
                            >
                                <div className="input-group input-group-sm">
                                    <select
                                        className="form-select border-primary"
                                        id="updateBidOption"
                                        style={{ maxWidth: 200 }}
                                    >
                                        <option value="absolute">
                                            Change Bid
                                        </option>
                                        <option value="percentIncrease">
                                            Increase Bid by %
                                        </option>
                                        <option value="percentDecrease">
                                            Decrease Bid by %
                                        </option>
                                    </select>
                                    <input
                                        className="form-control border-primary"
                                        id="updateBidInput"
                                        type="text"
                                    />
                                    <button
                                        className="btn btn-sm rounded-end btn-primary"
                                        id="updateBidBtn"
                                        type="button"
                                        data-bs-name="Update"
                                        onClick={(event) => {
                                            bulkActionChangeSubmit(
                                                $(
                                                    "#updateBidOption option:selected"
                                                ).val() as string,
                                                "keywords",
                                                { isBulkAction: true, event }
                                            );
                                        }}
                                    >
                                        Update
                                    </button>
                                    <button
                                        className="btn btn-sm text-primary"
                                        id="clearBidBtn"
                                        type="button"
                                        onClick={hideChangeBid}
                                    >
                                        Clear
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : null}
        </>
    ) : (
        <>
            <div className="me-1" id="bulk-operations-div">
                <BulkActionsMenu data={bulkActionData} />
            </div>
            <UpdateBidOrBudgetModal type="bid" />
        </>
    );
};

export default KeywordsBulkOperationsBtns;
